import React,{ useEffect, useState } from 'react'
import {useHistory} from "react-router-dom";
import ModalInformativo from '../generales/ModalInformativo'
import axios from "axios";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import { Box, FormControl, TextField, InputLabel, Button, Select, MenuItem, LinearProgress } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { obtenDispo } from '../funciones/IdDispositivo';
import TablaBusqueda from './TablaBusqueda';
//import SelectEdo from '../generales/SelectEdo';
const BusqSeccion = ({modalAbierto,setModalAbierto,}) => {
  const history = useHistory();
  const source = axios.CancelToken.source();
  const usuID = localStorage.getItem('UsuId');
  const auxDispV =obtenDispo()
  const[aviso,setAviso]=useState(false)
  const[espera,setEspera]=useState(false)
  const[textoSecc,setTextoSecc]=useState("")
  const[respuesta,setRespuesta]=useState("")
  const[filtro,setFiltro]=useState({tipo:""})
  const[listTipo,setListTipo]=useState([])
  const [edo,setEdo]=useState('')
  const{tipo} = filtro

  useEffect(()=>{
    getListTipo()
  },[])

  function getListTipo()  {  
    const url= `/busqueda/tipo`;                            
    const data = qs.stringify({                
        Usuario:usuID,                          
        idDispositivo:auxDispV,
    });
                
    function respuesta (aux) 
    { if (aux[0].Id !==  -1 ) 
      { 
        setListTipo(aux)               
      }                                                                   
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
  }; 

  const llenalistMun = (  ) => {
    setRespuesta( [])
    const data = qs.stringify({       
      Usuario: usuID,
      Tipo:tipo,
      Cadena:textoSecc,
      idDispositivo: "987gyubjhkkjh",
    });
    const url = "/busqueda/filtro";
  
    function respuesta(aux) {
      if (aux && aux[0].Id !==0 && aux[0].Id !=="0"  ) 
      {
        setRespuesta( aux )
      }       
    }
  
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
  }; 

  const onChange = e => {
    setTextoSecc( e.target.value)
  }

  const Busqueda=()=>{
    if (tipo !== ""  ) {
      llenalistMun(textoSecc)
    }
  }

  const onChangeSlct=(e)=>{            
    if (e!== null && e!== undefined) 
   {  setFiltro({[e.target.name]:e.target.value})   
      setRespuesta([])
      setTextoSecc("")
   }
   else
   {  setFiltro({[e.target.name]:""})        
   }        
  }

  return (
  <ModalInformativo   titulo="Busqueda "
    modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto}
    tamanio="md"
  >
    <Box display={"flex"} flexDirection={"column"} style={{alignItems:"center"}}>
      <Box display={"flex"} flexDirection={"row"}>
      <Box mr={1}>
      {listTipo.length!==0?
       <FormControl size='small'>
        <InputLabel size='small' variant="outlined" id="Tipo-label-nvo">Tipo</InputLabel>
          <Select size='small' variant="outlined" style={{width: '22rem'}}
            label="Tipo" id="TipoFiltro-select2" name="tipo"
            value={tipo} onChange={onChangeSlct}
            fullWidth
          >
            {listTipo.map((zona,  ) => {
              return (
              <MenuItem size='small' value={zona.Id} key={zona.Id}>
                  <em>{`${zona.Nom}`}</em>
              </MenuItem>
              )
              }
            )}
        </Select>
      </FormControl> 
      :null}
      </Box>  
      
      <TextField required id="textoSecc-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:12+'rem',marginRight:"1.5rem"}}
        label="Texto a buscar" value={textoSecc} name='NombtextoSeccre'size="small" autoComplete='off' // defaultValue="Nombre"                                
      />
      <Box mt={1}>
      <Button onClick={Busqueda} style={{width:"7rem", backgroundColor:process.env.REACT_APP_Btn_Color}} size='small'
        variant="contained"  color="primary"  startIcon={<SearchIcon/>} >   
        Buscar     
      </Button>
      </Box>
      </Box>
      <Box>
      { respuesta.length!==0 && !espera? 
      <Box mt={1}  width={"51rem"} >
        <TablaBusqueda lista={respuesta} tipo={tipo}/>
      </Box>
      : espera? <Box mt={3} width={"40rem"}><LinearProgress/></Box> 
        :null}
      </Box>
    </Box>
  </ModalInformativo>
  )
}

export default BusqSeccion